var map = {
	"./horoscope-icon-white-0.png": 188,
	"./horoscope-icon-white-1.png": 189,
	"./horoscope-icon-white-10.png": 190,
	"./horoscope-icon-white-11.png": 191,
	"./horoscope-icon-white-2.png": 192,
	"./horoscope-icon-white-3.png": 193,
	"./horoscope-icon-white-4.png": 194,
	"./horoscope-icon-white-5.png": 195,
	"./horoscope-icon-white-6.png": 196,
	"./horoscope-icon-white-7.png": 197,
	"./horoscope-icon-white-8.png": 198,
	"./horoscope-icon-white-9.png": 199
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes ^\.\/horoscope\-icon\-white\-.*\.png$
// module id = 72
// module chunks = 0